import * as tslib_1 from "tslib";
import updateQueryString from '../actions/updateQueryString';
import convertPersonaToRecipientPersonaProps from '../utils/convertPersonaToRecipientPersonaProps';
import updateFindResultTransactionId from 'owa-readwrite-recipient-well/lib/actions/updateFindResultTransactionId';
import getAndPopulateSuggestedContacts from 'owa-recipient-common/lib/actions/getAndPopulateSuggestedContacts';
export default function getSuggestedContacts(viewState, recipients) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updateQueryString(viewState, '');
                    return [4 /*yield*/, getAndPopulateSuggestedContacts(viewState.findResultSet, recipients)];
                case 1:
                    _a.sent();
                    updateFindResultTransactionId(viewState);
                    return [2 /*return*/, convertPersonaToRecipientPersonaProps(viewState.findResultSet)];
            }
        });
    });
}
//# sourceMappingURL=getSuggestedContacts.js.map